import { CommonModule } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { BreakpointService } from '@shure/cloud/shared/services/media-breakpoints';
import { PrismTooltipComponent } from '@shure/prism-angular-components';

type CellRendererParams = ICellRendererParams<object, string[]>;

@Component({
	selector: 'sh-device-tags-renderer',
	standalone: true,
	imports: [CommonModule, PrismTooltipComponent],
	templateUrl: './device-tags-renderer.component.html',
	styleUrl: './device-tags-renderer.component.scss'
})
export class DeviceTagsRendererComponent implements ICellRendererAngularComp {
	public enableTooltip = signal(false);
	private readonly tags = signal<string[]>([]);

	public displayValue = computed(() => {
		return this.tags().join(', ');
	});

	constructor(private readonly breakpointService: BreakpointService) {}

	public agInit(params: CellRendererParams): void {
		this.update(params);
		this.enableTooltip = this.breakpointService.hasPointer;
	}

	/**
	 * @param _params
	 * @returns a boolean to indicate if you have managed the cell refresh yourself
	 */
	public refresh(params: CellRendererParams): boolean {
		this.update(params);
		return false;
	}

	private update(params: CellRendererParams): void {
		this.tags.set([...(params.value ?? [])].sort());
	}
}
